import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
// import { bodyScrollHandler } from "../../../common/utills";
import ImageCropper from './index';
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const CropperPortal = props => {
    const history = useHistory();
	const isMobile = useSelector(state => state.library.deviceData.isMobile);
	const cropperData = useSelector(state => state.products.cropperData);
	const editProduct = useSelector(state => state.products.editProduct);
    const allProducts = useSelector(state => state.products.allProducts);
    const variantProductData = useSelector(state => state.variants.variantProductData)
    let variantData = variantProductData?.length ? variantProductData : cropperData.uploadProps?.variantProducts;
    const productData = editProduct ? editProduct : allProducts[cropperData.listingProductData.productId];
    const session = useSelector(state => state.session);

    const div = '#react-slider-holder';
    const Wrapper = React.Fragment;
    return ReactDOM.createPortal(
        <Wrapper>
            <ImageCropper 
                    data={[{
                        src: cropperData.src,
                        imgUrl: cropperData.src,
                        prefWidth: 450,
                        prefHeight: 450
                    }]}
                    productData={productData || cropperData.listingProductData}
                    fromListing={cropperData.listingProductData}
                    variantData={variantData}
                    selectedImageIndex={cropperData.selectedImageIndex}
                    isMobile={isMobile}
                    uploadProps={cropperData.uploadProps}
                    hasGlassFooter={session.hasGlassFooter}
                />
        </Wrapper>,
        document.querySelector(div)
    );

}

export default CropperPortal;